<template>

<app-table-cell class="schedule" :class="{'is-placing': placing}" :border="border" v-click-outside="onOutsideClick">

	<div class="schedule-slot" v-on:click="onSlotClick(index, slot)" v-on:mouseenter="onSlotEnter(index)" v-on:mouseleave="onSlotLeave(index, slot.scheduled)" v-for="(slot, index) in slots" :key="index" v-tooltip="slot.tooltip" :class="{'is-scheduled': slot.scheduled, 'is-approval': slot.approval, 'is-start-approval': slot.startApproval, 'is-end-approval': slot.endApproval, 'is-start': slot.start, 'is-end': slot.end, 'is-highlighted': slot.highlighted, 'is-hovering': slot.hovering, 'is-selected': slot.selected}" :data-selected="slot.selected" :data-current="slot.current">
        <div class="schedule-current"></div>
        <div class="schedule-placement"></div>
    </div>

</app-table-cell>

</template>

<script>

export default {

	props: ['border', 'day', 'space', 'event', 'placing', 'highlights', 'current', 'start', 'scheduled', 'end', 'times'],

    data: function() {
    
        return {
            placingStart: 0,
            placingEnd: 0,
            placingMax: 0,
            placingHover: 0
        }

    },

    computed: {

        isPlacing: function() {
        
            return this.placingStart && !this.placingEnd

        },

        isPlaced: function() {
        
            return this.placingStart && this.placingEnd

        },
    
        slots: function() {
        
            var slots = {}, tooltip, isHovering, isHighlighted, isSelected, isCurrent

            this.$_.each(this.times, function(time, value) {

                value = parseInt(value)

                if (value >= this.start && value <= this.end) {

                    tooltip = time

                    isCurrent = false

                    if(this.isPlacing) {

                        isSelected = (this.placingStart === value) ? true : false
                        isHovering = (this.placingHover == value && value >= this.placingStart) ? true : false

                    } else if(this.isPlaced) {
                    
                        isSelected = (this.placingStart <= value && this.placingEnd >= value) ? true : false

                    }
                    
                    isHovering = (this.placingHover == value) ? true : false

                    isHighlighted = false

                    if(this.highlights) {

                        this.$_.each(this.highlights, function(highlight) {

                            isHighlighted = (highlight.time <= value && highlight.time + highlight.duration > value) ? true : isHighlighted
                        
                        })

                    }

                    if (isHovering) {

                        if(isSelected) {
                        
                            tooltip = time + '<span>Click to cancel selection</span>'

                        } else {

                            if (this.placing) {
                            
                                tooltip = (this.placingStart < value && this.isPlacing) ? time + '<span>Click to select end time</span>' : time + '<span>Click to select start time</span>'
                            
                            } else {

                                tooltip = time + '<span>This slot is available</span>'
                            
                            }

                        
                        }
                    
                    }

                    if (isSelected) {
                    
                        if(value === this.placingStart) isSelected = 'start';
                        else if(value === this.placingEnd) isSelected = 'end';
                        else isSelected = 'middle';
                    
                    }

                    if (this.current) {
                    
                        isCurrent = (value >= this.current.time && value <= this.current.duration + this.current.time) ? true : false

                    }

                    if (isCurrent) {
                    
                        if(value === this.current.time) isCurrent = 'start';
                        else if(value === this.current.time + this.current.duration) isCurrent = 'end';
                        else isCurrent = 'middle';
                    
                    }
                
                    slots[value] = {
                        tooltip: tooltip,
                        value: value,
                        time: time,
                        highlighted: isHighlighted,
                        scheduled: false,
                        approval: 0,
                        start: false,
                        end: false,
                        selected: isSelected,
                        current: isCurrent,
                        hovering: isHovering
                    }
                
                }
            
            }.bind(this))

            this.$_.each(this.$_.sortBy(this.scheduled, 'time'), function(event) {

                if (event.day === parseInt(this.day) && event.space === this.space) {

                    for(var i = event.time; i <= event.duration + event.time; i += 5) {
                    
                        if(slots[i] !== undefined) {

                            var approval = this.$_.contains([
                                this.$constants.schedule.suggestions.status.approved,
                                this.$constants.schedule.suggestions.status.preapproved
                            ], event.status)

                            slots[i].start = i === event.time || slots[i].start
                            slots[i].startApproval = (i === event.time) ? approval : slots[i].startApproval

                            slots[i].end = i === event.duration + event.time || slots[i].end
                            slots[i].endApproval = (i === event.duration + event.time) ? approval : slots[i].endApproval

                            slots[i].approval = approval

                            slots[i].scheduled = true

                        }
                    
                    }
                
                }
            
            }.bind(this))

            this.$_.each(slots, function(slot) {
            
                if ((slot.start && !this.isPlacing) || (slot.scheduled && !slot.start && !slot.end) || (this.isPlacing && slot.value > this.placingMax)) {
                
                    slot.tooltip = slot.time + '<span>This slot is unavailable</span>'

                }
            
            }.bind(this))

            return slots
        
        },

        hasPlacingDuration: function() {
        
            return this.placing !== true
        
        }
    
    },

    methods: {

        onSlotClick: function(value, slot) {

            if (!this.placing) return false
            if (slot.start && slot.end) return false
            if (slot.start && !this.isPlacing) return false
            if (slot.scheduled && !slot.start && !slot.end) return false

            value = parseInt(value) 

            if (this.isPlacing) {

                if (value > this.placingMax) return false
            
                if (this.placingStart === value) {
                
                    this.placingStart = 0
                    this.placingEnd = 0

                } else if (this.placingStart > value) {
                
                    this.placingStart = value
                    this.placingEnd = 0
                    this.placingMax = 0
                
                } else {
                
                    this.placingEnd = value
            
                    this.$emit('placed', {
                        time: this.placingStart,
                        duration: this.placingEnd - this.placingStart
                    })

                    this.placingStart = 0
                    this.placingEnd = 0

                }
            
            } else {
            
                this.placingStart = value
                this.placingEnd = 0
            
            }

            var blocked = false

            this.$_.each(this.slots, function(slot) {

                if(slot.value > this.placingStart && ((slot.scheduled && !slot.start) || slot.end)) {
                        
                    blocked = true
                        
                } else if (slot.value >= this.placingStart && !blocked) {
                        
                    this.placingMax = slot.value
                        
                }
                
            }.bind(this))

        },
    
        onSlotEnter: function(value) {

            this.placingHover = parseInt(value)

        },

        onSlotLeave: function() {

            this.placingHover = 0

        },

		onOutsideClick: function(e) {

			if (this.isPlacing) {
            
                if (e.target.className === 'schedule-placement') this.placingStart = 0
            
            }

		}
    
    }

}

</script>

<style scoped>

.schedule {
    display: grid;
    flex-direction: row;
    height: 52px;
    padding: 0px!important;
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
    grid-template-rows: 1fr;
	align-items: initial!important;
}

.schedule-slot {
	background-color: #4faa80;
}

.schedule-slot:before {
    content: '';
    display: block;
    width: 2px;
    position: absolute;
    left: 50%;
    margin-left: -1px;
    top: 0px;
    height: 51px;
    z-index: 12;
    background-color: rgba(255, 255, 255, 0.25);
}

.schedule-slot.is-hovering:before {
    background-color: rgba(255, 255, 255, 1);
    z-index: 21;
}

.schedule.is-placing .slot-placement {
    cursor: pointer;
}

.schedule-slot.is-highlighted {
	background-color: #4a8765;
}

.schedule-slot.is-scheduled:not(.is-start):not(.is-end) {
	background-color: #c55b5b;
}

.schedule-slot.is-scheduled.is-approval:not(.is-start):not(.is-end) {
	background-color: #ff7a7a;
}

.schedule-slot.is-start .schedule-current,
.schedule-slot.is-end .schedule-current {
	background-color: #c55b5b;
    width: 50%;
    margin-left: 50%;
}

.schedule-slot.is-end .schedule-current {
    margin-left: 0%;
}

.schedule-slot.is-end.is-start .schedule-current {
    width: 100%;
}

.schedule-slot.is-start:not(.is-end).is-approval .schedule-current,
.schedule-slot.is-end:not(.is-start).is-approval .schedule-current,
.schedule-slot.is-start.is-end.is-start-approval .schedule-current,
.schedule-slot.is-start-approval.is-end-approval .schedule-current {
	background-color: #ff7a7a;
}

.schedule-slot.is-end.is-start .schedule-current:before {
    position: absolute;
    content: '';
    left: 0px;
    top: 0px;
    width: 50%;
    height: 100%;
	background-color: #c55b5b;
}

.schedule-slot.is-end.is-start.is-end-approval .schedule-current:before {
	background-color: #ff7a7a;
}

.schedule-current {
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 1;
}

.schedule-placement {
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 20;
}

.schedule-slot.is-hovering .schedule-placement {
	background-color: rgba(0, 0, 0, 0.25);
    cursor: pointer;
    clip-path: polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%);
}

.schedule-slot[data-selected="start"] .schedule-placement:after,
.schedule-slot[data-selected="end"] .schedule-placement:after,
.schedule-slot[data-selected="start"] .schedule-placement:before,
.schedule-slot[data-selected="end"] .schedule-placement:before,
.schedule-slot[data-selected="middle"] .schedule-placement:after {
    content: '';
    display: block;
    position: absolute;
    background-color: #ffbe7a;
    top: 50%;
}

.schedule-slot[data-current="start"] .schedule-current:after,
.schedule-slot[data-current="end"] .schedule-current:after,
.schedule-slot[data-current="start"] .schedule-current:before,
.schedule-slot[data-current="end"] .schedule-current:before,
.schedule-slot[data-current="middle"] .schedule-current:after {
    content: '';
    display: block;
    position: absolute;
    background-color: #bafcaf;
    top: 50%;
}

.schedule-slot[data-selected="start"] .schedule-placement:after,
.schedule-slot[data-selected="end"] .schedule-placement:after,
.schedule-slot[data-current="start"] .schedule-current:after,
.schedule-slot[data-current="end"] .schedule-current:after {
    width: 20px;
    height: 20px;
    left: 50%;
    margin-top: -10px;
    margin-left: -10px;
    border-radius: 50%;
}

.schedule-slot[data-selected="start"] .schedule-placement:before,
.schedule-slot[data-selected="end"] .schedule-placement:before,
.schedule-slot[data-current="start"] .schedule-current:before,
.schedule-slot[data-current="end"] .schedule-current:before {
    height: 2px;
    margin-top: -1px;
}

.schedule-slot[data-selected="start"] .schedule-placement:before,
.schedule-slot[data-current="start"] .schedule-current:before {
    width: 50%;
    left: 50%;
}

.schedule-slot[data-selected="end"] .schedule-placement:before,
.schedule-slot[data-current="end"] .schedule-current:before {
    width: 50%;
    left: 0%;
}

.schedule-slot[data-selected="middle"] .schedule-placement:after,
.schedule-slot[data-current="middle"] .schedule-current:after {
    width: 100%;
    height: 2px;
    left: 0%;
    margin-top: -1px;
}

.schedule-slot.is-start[data-current="start"] .schedule-current:before,
.schedule-slot.is-end[data-current="start"] .schedule-current:before {
    left: 100%;
    width: 100%;
}

.schedule-slot.is-start[data-current="start"] .schedule-current:after,
.schedule-slot.is-end[data-current="start"] .schedule-current:after {
    left: 100%;
}

.schedule-slot.is-start[data-current="end"] .schedule-current:before,
.schedule-slot.is-end[data-current="end"] .schedule-current:before {
    left: -100%;
    width: 100%;
}

.schedule-slot.is-start[data-current="end"] .schedule-current:after,
.schedule-slot.is-end[data-current="end"] .schedule-current:after {
    left: 0%;
}
	
</style>
